import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": {}
}
const recentChatItems = createSlice({
    name:'recentChatItems',
    initialState,
    reducers:{
        addrecentChatItems: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        }
    }
});

export default recentChatItems.reducer
export const addrecentChatItems = recentChatItems.actions.addrecentChatItems